module.exports = __webpack_public_path__ + "static/media/ieee-svcc.9403ad27.jpg";